var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import customerHeader from "./components/CustomerStockHeader.vue";
import businessStockService from "../../api/SalesReportService";
import TableList from "./components/tableList.vue";
import { Loading } from 'element-ui';
var stockList = (function (_super) {
    __extends(stockList, _super);
    function stockList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.service = businessStockService.getInstance();
        _this.fetchAction = _this.service.getBusinessStockList;
        _this.listData = [];
        _this.tableHeight = 300;
        _this.filter = {
            business_id: '',
            shop_city_ids: '',
            shop_type_id: '',
            shop_ids: null,
            goods_type_ids: [],
            keyword: '',
            unit_type: 'amount',
            stock_type: '1'
        };
        _this.total = 0;
        _this.sortColumns = [
            'wait_outamount',
            'wait_inamount',
            'amount',
            'price',
            'tax',
            'cost',
            'total'
        ];
        return _this;
    }
    stockList.prototype.created = function () {
        this.service = businessStockService.getInstance();
    };
    stockList.prototype.mounted = function () {
        var _this = this;
        setTimeout(function () {
            _this.tableHeight = document.documentElement.clientHeight - 265;
        }, 300);
    };
    stockList.prototype.getbusinessId = function (id) {
        this.filter.business_id = id;
    };
    stockList.prototype.pageChange = function () {
    };
    stockList.prototype.search = function (filter) {
        var _this = this;
        this.filter = JSON.parse(JSON.stringify(filter));
        this.filter.goods_type_ids = this.filter.goods_type_ids.join(',');
        this.filter.shop_ids = this.filter.shop_ids.join(',');
        this.$refs.pagination && this.$refs.pagination.clear();
        this.loadingInstance = Loading.service({ fullscreen: true });
        this.$nextTick(function () {
            _this.$refs.TableList.fetch();
        });
        this.loadingInstance.close();
    };
    stockList = __decorate([
        Component({
            components: {
                'list-header': customerHeader,
                'table-list': TableList
            }
        })
    ], stockList);
    return stockList;
}(Vue));
export default stockList;
